import { conexaoDB } from "./db";

async function salvarUsuariosRelacionados(usuarios) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["usuarios-relacionados"], "readwrite")
    .objectStore("usuarios-relacionados");
  objectStore.clear();
  usuarios.forEach((usr) => {
    objectStore.add(usr);
  });

  await setarUsuarioLogado(usuarios[0]);
}

async function setarUsuarioLogado(user) {
  const db = await conexaoDB();
  const objectStore = db
    .transaction(["usuario-logado"], "readwrite")
    .objectStore("usuario-logado");
  objectStore.clear();
  if(user != null)
    objectStore.put(user);
}

async function getUsuarios() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    const query = db
      .transaction(["usuarios-relacionados"])
      .objectStore("usuarios-relacionados")
      .getAll();
    query.onsuccess = (event) => {
      resolve(JSON.parse(JSON.stringify(event.target.result)));
    };
  });
}

async function getUsuarioLogado() {
  const db = await conexaoDB();
  return new Promise((resolve) => {
    try {
      const query = db
        .transaction(["usuario-logado"])
        .objectStore("usuario-logado")
        .getAll();
      query.onsuccess = (event) => {
        try {
          resolve(JSON.parse(JSON.stringify(event.target.result[0])));
        } catch (error) {
          resolve(null);
        }
      };
    } catch (error) {
      resolve(null);
    }
  });
}

export {
  salvarUsuariosRelacionados,
  getUsuarios,
  getUsuarioLogado,
  setarUsuarioLogado,
};
